/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Badge, Box, Flex, Text, Image, Icon, Avatar } from '@chakra-ui/react';
import { VscError } from 'react-icons/vsc';
import { AiOutlineAudio, AiOutlineCheckCircle } from 'react-icons/ai';
import { GoDotFill } from 'react-icons/go';
import { MdOndemandVideo } from 'react-icons/md';
import { CgFileDocument } from 'react-icons/cg';
import { handleImgError } from './HandleFunctions';

export const getCellExclusive = (v) => {
  if (v === true) {
    return <AiOutlineCheckCircle color="#15B042" fontSize={18} />;
  }
  return <VscError color="#D63D3D" fontSize={18} />;
};

export const getCellStatus = (v) => {
  if (v === 1 || v === true) {
    return <Badge variant="success">Ativo</Badge>;
  }
  return <Badge variant="destructive">Inativo</Badge>;
};

export const getCellColor = (value: any) => {
  if (value)
    return (
      <Flex align="center">
        <Box bg={value} borderRadius="5px" w="20px" h="20px" mr="5px" />
        <Text>{value}</Text>
      </Flex>
    );
  return 'Não informado';
};

export const getCellImage = (value: any, useAvatar = false) => {
  return (
    <>
      {useAvatar ? (
        <Avatar size="sm" w="32px" h="32px" src={value?.medium ?? ''} />
      ) : (
        <Image
          w="36px"
          h="36px"
          objectFit="cover"
          borderRadius="8px"
          border="1px solid"
          borderColor="line.hairline"
          onError={handleImgError}
          src={value?.medium ?? ''}
        />
      )}
    </>
  );
};

export const getFileTypeIcon = (value: any) => {
  if (value === 'video')
    return (
      <Flex align="center">
        <Icon as={MdOndemandVideo} mr="6px" fontSize="16px" />
        <Text>Vídeo</Text>
      </Flex>
    );
  if (value === 'audio')
    return (
      <Flex align="center">
        <Icon as={AiOutlineAudio} mr="6px" fontSize="16px" />
        <Text>Audio</Text>
      </Flex>
    );
  if (value === 'docs')
    return (
      <Flex align="center">
        <Icon as={CgFileDocument} mr="6px" fontSize="16px" />
        <Text>Documento</Text>
      </Flex>
    );
  return 'Não informado';
};

export const getStatusDot = (value: any) => {
  if (value.length > 0)
    return [
      ...(value?.map((item) => (
        <Flex align="center">
          <Icon as={GoDotFill} mr="5px" color={item.status ? 'green' : 'red'} fontSize="15px" />
          <Text>{item.name}</Text>
        </Flex>
      )) ?? []),
    ];
  return 'Não informado';
};

export const getArrayItems = (value: any) => {
  if (value && value.length === 0) {
    return <Text>Todos</Text>;
  }
  return <Text>{value?.map((item) => item.name).join(', ')}</Text>;
};
export const getArrayItemsNull = (value: any) => {
  if (value && value.length === 0) {
    return <Text>Todos</Text>;
  }

  return <Text>{value?.map((item) => item?.name).join(', ')}</Text>;
};

export const getAttachmentType = (type) => {
  switch (type) {
    case 1:
      return 'IMAGEM';
    case 2:
      return 'WORD';
    case 3:
      return 'PDF';
    case 4:
      return 'EXCEL';
    case 5:
      return 'POWER POINT';
    case 6:
      return 'ÁUDIO';
    case 7:
      return 'VÍDEO';
    default:
      return 'DESCONHECIDO';
  }
};

export const getFormattedLabel = (item) => {
  return {
    value: item.id,
    label: item.name ?? item.id,
  };
};
